module.exports = __webpack_public_path__ + "media/theme/PC_top_02-b8186633.png";